"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _cccisdApollo = require("cccisd-apollo");
var _cccisdAxios = _interopRequireDefault(require("cccisd-axios"));
var _cccisdClickButton = _interopRequireDefault(require("cccisd-click-button"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdHiddenBlock = _interopRequireDefault(require("cccisd-hidden-block"));
var _envelop = _interopRequireDefault(require("cccisd-icons/envelop2"));
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdNotification = _interopRequireDefault(require("cccisd-notification"));
var _cccisdTable = _interopRequireDefault(require("cccisd-table"));
var _pawns = _interopRequireDefault(require("./pawns.graphql"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return r; }; var t, r = {}, e = Object.prototype, n = e.hasOwnProperty, o = "function" == typeof Symbol ? Symbol : {}, i = o.iterator || "@@iterator", a = o.asyncIterator || "@@asyncIterator", u = o.toStringTag || "@@toStringTag"; function c(t, r, e, n) { return Object.defineProperty(t, r, { value: e, enumerable: !n, configurable: !n, writable: !n }); } try { c({}, ""); } catch (t) { c = function c(t, r, e) { return t[r] = e; }; } function h(r, e, n, o) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype); return c(a, "_invoke", function (r, e, n) { var o = 1; return function (i, a) { if (3 === o) throw Error("Generator is already running"); if (4 === o) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var u = n.delegate; if (u) { var c = d(u, n); if (c) { if (c === f) continue; return c; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (1 === o) throw o = 4, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = 3; var h = s(r, e, n); if ("normal" === h.type) { if (o = n.done ? 4 : 2, h.arg === f) continue; return { value: h.arg, done: n.done }; } "throw" === h.type && (o = 4, n.method = "throw", n.arg = h.arg); } }; }(r, n, new Context(o || [])), !0), a; } function s(t, r, e) { try { return { type: "normal", arg: t.call(r, e) }; } catch (t) { return { type: "throw", arg: t }; } } r.wrap = h; var f = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var l = {}; c(l, i, function () { return this; }); var p = Object.getPrototypeOf, y = p && p(p(x([]))); y && y !== e && n.call(y, i) && (l = y); var v = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(l); function g(t) { ["next", "throw", "return"].forEach(function (r) { c(t, r, function (t) { return this._invoke(r, t); }); }); } function AsyncIterator(t, r) { function e(o, i, a, u) { var c = s(t[o], t, i); if ("throw" !== c.type) { var h = c.arg, f = h.value; return f && "object" == _typeof(f) && n.call(f, "__await") ? r.resolve(f.__await).then(function (t) { e("next", t, a, u); }, function (t) { e("throw", t, a, u); }) : r.resolve(f).then(function (t) { h.value = t, a(h); }, function (t) { return e("throw", t, a, u); }); } u(c.arg); } var o; c(this, "_invoke", function (t, n) { function i() { return new r(function (r, o) { e(t, n, r, o); }); } return o = o ? o.then(i, i) : i(); }, !0); } function d(r, e) { var n = e.method, o = r.i[n]; if (o === t) return e.delegate = null, "throw" === n && r.i["return"] && (e.method = "return", e.arg = t, d(r, e), "throw" === e.method) || "return" !== n && (e.method = "throw", e.arg = new TypeError("The iterator does not provide a '" + n + "' method")), f; var i = s(o, r.i, e.arg); if ("throw" === i.type) return e.method = "throw", e.arg = i.arg, e.delegate = null, f; var a = i.arg; return a ? a.done ? (e[r.r] = a.value, e.next = r.n, "return" !== e.method && (e.method = "next", e.arg = t), e.delegate = null, f) : a : (e.method = "throw", e.arg = new TypeError("iterator result is not an object"), e.delegate = null, f); } function w(t) { this.tryEntries.push(t); } function m(r) { var e = r[4] || {}; e.type = "normal", e.arg = t, r[4] = e; } function Context(t) { this.tryEntries = [[-1]], t.forEach(w, this), this.reset(!0); } function x(r) { if (null != r) { var e = r[i]; if (e) return e.call(r); if ("function" == typeof r.next) return r; if (!isNaN(r.length)) { var o = -1, a = function e() { for (; ++o < r.length;) if (n.call(r, o)) return e.value = r[o], e.done = !1, e; return e.value = t, e.done = !0, e; }; return a.next = a; } } throw new TypeError(_typeof(r) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, c(v, "constructor", GeneratorFunctionPrototype), c(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = c(GeneratorFunctionPrototype, u, "GeneratorFunction"), r.isGeneratorFunction = function (t) { var r = "function" == typeof t && t.constructor; return !!r && (r === GeneratorFunction || "GeneratorFunction" === (r.displayName || r.name)); }, r.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, c(t, u, "GeneratorFunction")), t.prototype = Object.create(v), t; }, r.awrap = function (t) { return { __await: t }; }, g(AsyncIterator.prototype), c(AsyncIterator.prototype, a, function () { return this; }), r.AsyncIterator = AsyncIterator, r.async = function (t, e, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(h(t, e, n, o), i); return r.isGeneratorFunction(e) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, g(v), c(v, u, "Generator"), c(v, i, function () { return this; }), c(v, "toString", function () { return "[object Generator]"; }), r.keys = function (t) { var r = Object(t), e = []; for (var n in r) e.unshift(n); return function t() { for (; e.length;) if ((n = e.pop()) in r) return t.value = n, t.done = !1, t; return t.done = !0, t; }; }, r.values = x, Context.prototype = { constructor: Context, reset: function reset(r) { if (this.prev = this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(m), !r) for (var e in this) "t" === e.charAt(0) && n.call(this, e) && !isNaN(+e.slice(1)) && (this[e] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0][4]; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(r) { if (this.done) throw r; var e = this; function n(t) { a.type = "throw", a.arg = r, e.next = t; } for (var o = e.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i[4], u = this.prev, c = i[1], h = i[2]; if (-1 === i[0]) return n("end"), !1; if (!c && !h) throw Error("try statement without catch or finally"); if (null != i[0] && i[0] <= u) { if (u < c) return this.method = "next", this.arg = t, n(c), !0; if (u < h) return n(h), !1; } } }, abrupt: function abrupt(t, r) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var n = this.tryEntries[e]; if (n[0] > -1 && n[0] <= this.prev && this.prev < n[2]) { var o = n; break; } } o && ("break" === t || "continue" === t) && o[0] <= r && r <= o[2] && (o = null); var i = o ? o[4] : {}; return i.type = t, i.arg = r, o ? (this.method = "next", this.next = o[2], f) : this.complete(i); }, complete: function complete(t, r) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && r && (this.next = r), f; }, finish: function finish(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[2] === t) return this.complete(e[4], e[3]), m(e), f; } }, "catch": function _catch(t) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var e = this.tryEntries[r]; if (e[0] === t) { var n = e[4]; if ("throw" === n.type) { var o = n.arg; m(e); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(r, e, n) { return this.delegate = { i: x(r), r: e, n: n }, "next" === this.method && (this.arg = t), f; } }, r; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Appdefs = window.cccisd.appDefs;
var Boilerplate = window.cccisd.boilerplate;
var BulkInvite = function BulkInvite(_ref) {
  var closeModal = _ref.closeModal,
    deselectAll = _ref.deselectAll,
    loadData = _ref.loadData,
    selectedRows = _ref.selectedRows,
    settings = _ref.settings;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoading = _useState2[0],
    setIsLoading = _useState2[1];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    pawns = _useState4[0],
    setPawns = _useState4[1];
  var role = settings === null || settings === void 0 ? void 0 : settings.role;
  function showSubject() {
    var subject = '';
    if (role) {
      subject = (0, _get2["default"])(Appdefs, "app.siteContent.".concat(role, ".activationEmail.subject"), '');
    }
    if (!subject) {
      subject = (0, _get2["default"])(Appdefs, 'app.siteContent.activationEmail.subject', '');
    }
    return subject || 'User Registration Site Access';
  }
  function showBody() {
    var body = '';
    if (role) {
      body = (0, _get2["default"])(Appdefs, "app.siteContent.".concat(role, ".activationEmail.body"), '');
    }
    if (!body) {
      body = (0, _get2["default"])(Appdefs, 'app.siteContent.activationEmail.body', '');
    }
    return body || 'Use the link below to register for site access';
  }
  (0, _react.useEffect)(function () {
    function loadPawnData() {
      return _loadPawnData.apply(this, arguments);
    }
    function _loadPawnData() {
      _loadPawnData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var resp;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              setIsLoading(true);
              _context.next = 3;
              return _cccisdApollo.client.query({
                query: _pawns["default"],
                variables: {
                  pawns: selectedRows
                },
                fetchPolicy: 'network-only'
              });
            case 3:
              resp = _context.sent;
              setPawns(resp.data.roles.anyRoleList);
              setIsLoading(false);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _loadPawnData.apply(this, arguments);
    }
    loadPawnData();
  }, []);
  function handleSubmit(_x) {
    return _handleSubmit.apply(this, arguments);
  }
  function _handleSubmit() {
    _handleSubmit = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2(values) {
      var resp;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _cccisdAxios["default"].put(Boilerplate.route('api.nexus.pawn.bulk'), _objectSpread({
              action: 'invite',
              data: pawns.filter(function (p) {
                return p.user.email && !p.user.activated;
              }).map(function (p) {
                return {
                  id: p.pawn.pawnId,
                  hash: p.pawn.pawnHash
                };
              })
            }, values));
          case 2:
            resp = _context2.sent;
            if (!resp.data.errors) {
              _context2.next = 6;
              break;
            }
            (0, _cccisdNotification["default"])({
              type: 'danger',
              message: 'Invite failed',
              data: resp.data.errors
            });
            return _context2.abrupt("return");
          case 6:
            (0, _cccisdNotification["default"])({
              type: 'success',
              message: 'Emails sent successfully!'
            });
            closeModal();
            loadData();
            deselectAll();
          case 10:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _handleSubmit.apply(this, arguments);
  }
  if (isLoading || !pawns) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
      type: "inline",
      loading: true
    });
  }

  // more efficient to only loop once for each list
  var noEmail = [];
  var alreadyActivated = [];
  var alreadyInvited = [];
  var notInvited = [];
  pawns.forEach(function (p) {
    var formatted = _objectSpread(_objectSpread(_objectSpread({}, p.user), p.pawn), {}, {
      group: p.parentGroup.anyGroup.group.label
    });
    if (!formatted.email) {
      noEmail.push(formatted);
    } else if (formatted.activated) {
      alreadyActivated.push(formatted);
    } else if (formatted.invited) {
      alreadyInvited.push(formatted);
    } else {
      notInvited.push(formatted);
    }
  });
  var commonTableProps = {
    columns: [{
      name: 'username',
      label: 'Username',
      sort: true,
      filter: true
    }, {
      name: 'firstName',
      label: 'First Name',
      sort: true,
      filter: true
    }, {
      name: 'lastName',
      label: 'Last Name',
      sort: true,
      filter: true
    }, {
      name: 'group',
      label: 'Group',
      sort: true,
      filter: true
    }],
    rowKey: 'pawnId',
    showPerPageOptions: false,
    perPage: 10
  };
  var sendTotal = alreadyInvited.length + notInvited.length;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, noEmail.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].section, " ").concat(_style["default"].error)
  }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-danger"
    }, /*#__PURE__*/_react["default"].createElement("b", null, noEmail.length), " user", noEmail.length === 1 ? '' : 's', " with no email address on record.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], _extends({
    name: "noEmail",
    data: noEmail
  }, commonTableProps))))), alreadyActivated.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(_style["default"].section, " ").concat(_style["default"].error)
  }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", {
      className: "text-danger"
    }, /*#__PURE__*/_react["default"].createElement("b", null, alreadyActivated.length), " user", alreadyActivated.length === 1 ? ' has' : 's have', " already been activated.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], _extends({
    name: "alreadyActivated",
    data: alreadyActivated
  }, commonTableProps))))), alreadyInvited.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, alreadyInvited.length), " user", alreadyInvited.length === 1 ? ' was' : 's were', ' ', "already invited and will be sent another invitation.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], _extends({
    name: "alreadyInvited",
    data: alreadyInvited
  }, commonTableProps))))), notInvited.length > 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].section
  }, /*#__PURE__*/_react["default"].createElement(_cccisdHiddenBlock["default"], {
    title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("b", null, notInvited.length), " user", notInvited.length === 1 ? '' : 's', " will be sent their first invitation.")
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].table
  }, /*#__PURE__*/_react["default"].createElement(_cccisdTable["default"], _extends({
    name: "notInvited",
    data: notInvited
  }, commonTableProps))))), sendTotal > 0 ? /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].emailDetails
  }, /*#__PURE__*/_react["default"].createElement("h4", null, "Send Account Activation email to ", sendTotal, " selected user", sendTotal === 1 ? '' : 's'), /*#__PURE__*/_react["default"].createElement("p", null, "Enter your message to be sent to the users. The greeting and activation link will be included in the email."), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Formik, {
    initialValues: {
      body: showBody(),
      subject: showSubject()
    },
    onSubmit: handleSubmit
  }, function (formikBag) {
    return /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Form, null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      component: _cccisdFormik.CccisdInput,
      name: "subject",
      label: "Subject"
    }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
      component: _cccisdFormik.CccisdWysiwyg,
      name: "body",
      label: "Body",
      type: "textarea",
      settings: {
        toolbar: ['bold italic underline'],
        menubar: false
      }
    }), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].btnContainer
    }, /*#__PURE__*/_react["default"].createElement("button", {
      type: "button",
      onClick: function onClick() {
        return closeModal();
      },
      className: "btn btn-secondary",
      disabled: formikBag.isSubmitting
    }, "Close"), /*#__PURE__*/_react["default"].createElement(_cccisdClickButton["default"], {
      title: /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement(_envelop["default"], null), "\xA0\xA0Send (", sendTotal, ")"),
      type: "button",
      className: "btn btn-success",
      onClick: formikBag.submitForm,
      isLoading: formikBag.isSubmitting
    })));
  })) : /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].btnContainer
  }, /*#__PURE__*/_react["default"].createElement("button", {
    type: "button",
    onClick: function onClick() {
      return closeModal();
    },
    className: "btn btn-secondary"
  }, "Close")));
};
BulkInvite.propTypes = {
  closeModal: _propTypes["default"].func,
  loadData: _propTypes["default"].func.isRequired,
  selectedRows: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  settings: function settings(props, propName, componentName) {
    var settings = props[propName];
    if (!settings) {
      return;
    }
    if (_typeof(settings) !== 'object') {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expected 'object', found ").concat(_typeof(settings), "."));
    }
    if (Array.isArray(settings) && settings.length > 0) {
      return new Error("Invalid prop ".concat(propName, " supplied to ").concat(componentName, ". Expected 'object', found 'array'."));
    }
  }
};
var _default = exports["default"] = BulkInvite;